document.addEventListener('DOMContentLoaded', function(){


$(document).ready(function () {
  quickView();
});
function quickView() {
  var modal = document.getElementById('quick-view');
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      $('#quick-view').removeClass();
    }
  };
  $(".quick-view").click(function () {
    event.preventDefault();
    var product_handle = $(this).data('handle');
    $('#quick-view'). attr("data-handle", product_handle);
    var collection_handle = $('.coll').data('handle');
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      // var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var quickviewPlace = $('.qv-product-options');
      var url = '/collections/' + collection_handle + '/products/' + product_handle;


      $('.qv-product-title').text(title);
      $('.qv-product-type').text(type);
      // $('.qv-product-description').html(desc);
      $('.view-product').attr('href', url);


      var quickview = $('.quick-view__modal-content');
      if (quickview.find('.qv-product-description').length > 0) {
        var description = product.description.replace(/(<([^>]+)>)/ig, "");
        description = description.split(" ").splice(0, 10).join(" ") + "...";
        quickview.find('.qv-product-description').text(description);
      } else {
        quickview.find('.qv-product-description').remove();
      }

      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
          $('.qv-product-images').slick({
            'dots': true,
            'arrows': true,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');
        } else {
          image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        }
      });
      //show options
      enercosQuickView.createQuickViewOptions(product,quickviewPlace);
      enercosQuickView.createQuickViewSwatch(product,quickviewPlace);
      enercosQuickView.reloadPrice(product_handle);
      //end show options

    });
	$(document).on("change", "#quick-view input[type=radio]", function () {
      var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
      var optionValue = jQuery(this).val();
      jQuery(this)
      .closest('#quick-view')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
    });  
    $(document).on("change", "#quick-view select", function () {
      enercosQuickView.reloadPrice(product_handle);
    });
    $('#quick-view').hide().html(quickViewContent).css('opacity', '1').fadeIn(function () {
      $('.qv-product-images').addClass('loaded');
    });
    modal.style.display = "block";
    var product_handle = $('#quick-view').attr('data-handle');
    $(document).on("click", ".quick-product", function () {
      var qty = $('.qv-quantity').val();
      var selectedOptions = '';
      var var_id = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var_id = v.id;
            processCart();
          }
        });
      });
      function processCart() {
        jQuery.post('/cart/add.js', {
          quantity: qty,
          id: var_id
        }, null, "json").done(function (data) {
          $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
          jQuery.getJSON('/cart.js', function (cart, textStatus) {
            $('#CartCount > span').html(cart.item_count);
            
            modal.style.display = "none";
            $('#quick-view').removeClass();
            $('#CartCount').trigger( "click" );
            
          });
        })
        .fail(function ($xhr) {
          var data = $xhr.responseJSON;
          $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
        });
      }
    });
  });
};

$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});
  var enercosQuickView = {
    createQuickViewOptions: function(product, quickviewPlace) {
      if (product.variants.length >= 1) {
        var options = product.options;
        $(options).each(function (index, option) {
          var opt = option.name;
          var selectClass = '.option.' + opt.toLowerCase();
          quickviewPlace.append('<div class="selector-wrapper js product-form__item '+enercosQuickView.convertToSlug(option.name+'-option')+'"><label for="SingleOptionSelector-'+index+'">'+option.name+'</label><select class="single-option-selector single-option-selector-product-template product-form__input" id="SingleOptionSelector-'+index+'" data-index="option'+index+'">  </select></div>');
          $(option.values).each(function (j, value) {
            var optionVal = value;
            $('#SingleOptionSelector-'+index).append('<option value="' + optionVal + '">' + value + '</option>');
          });
        });
      }
    },
    createQuickViewSwatch: function(product, quickviewPlace) {
      if (product.variants.length >= 1) { 
        var options = product.options;
        $(options).each(function (index, option) {
          var opt = option.name;
          var selectClass = '.option.' + opt.toLowerCase();
          var assetUrl = theme.assetsUrl.substring(0, theme.assetsUrl.lastIndexOf('?'));
		  var baseAssetUrl = assetUrl.replace("base.png", "");

          if(option.name.toLowerCase().indexOf("color") != -1 || option.name.toLowerCase().indexOf("colour") != -1){
            var swatchHtml = '';
            swatchHtml  = swatchHtml + '<div class="swatch  '+enercosQuickView.convertToSlug(option.name+'-option-hide')+'" data-option-index="'+index+'">';
            swatchHtml  = swatchHtml + '<div class="header">'+option.name+'</div>';
            $(option.values).each(function (j, value) {
              var optionVal = value;
              swatchHtml  = swatchHtml + '<div data-value="'+optionVal+'" class="swatch-element color '+enercosQuickView.convertToSlug(optionVal)+' soldout">';
              swatchHtml  = swatchHtml + '<div class="tooltip">'+optionVal+'</div>';
              swatchHtml  = swatchHtml + '<input id="swatch-'+index+'-'+optionVal+'" type="radio" name="option-'+index+'" value="'+optionVal+'" checked="">';
              swatchHtml  = swatchHtml + '<label for="swatch-'+index+'-'+optionVal+'" style="background-color: '+optionVal+'; background-image: url('+baseAssetUrl+optionVal+'.png)">';
              swatchHtml  = swatchHtml + '<img class="crossed-out" alt="" src="'+baseAssetUrl+'soldout.png">';
              swatchHtml  = swatchHtml + '</label>';
              swatchHtml  = swatchHtml + '</div>';
            });
            swatchHtml  = swatchHtml + '</div>';
            quickviewPlace.append(swatchHtml);
          }else{
            var swatchHtml = '';
            swatchHtml  = swatchHtml + '<div class="swatch '+enercosQuickView.convertToSlug(option.name+'-option-hide')+'" data-option-index="'+index+'">';
            swatchHtml  = swatchHtml + '<div class="header">'+option.name+'</div>';
            $(option.values).each(function (j, value) {
              var checked ='';
              if(j == 0) checked  = 'checked=""';
              var optionVal = value;
              swatchHtml  = swatchHtml + '<div data-value="'+optionVal+'" class="swatch-element '+enercosQuickView.convertToSlug(optionVal)+' soldout">';
              
              swatchHtml  = swatchHtml + '<input id="swatch-'+index+'-'+optionVal+'" type="radio" name="option-'+index+'" value="'+optionVal+'" '+checked+'>';
              swatchHtml  = swatchHtml + '<label for="swatch-'+index+'-'+optionVal+'">'+value;
              swatchHtml  = swatchHtml + '<img class="crossed-out" alt="" src="'+baseAssetUrl+'soldout.png">';
              swatchHtml  = swatchHtml + '</label>';
              
              swatchHtml  = swatchHtml + '</div>';
            });
            swatchHtml  = swatchHtml + '</div>';
            quickviewPlace.append(swatchHtml);
          }
        });
      }
    },
    convertToSlug: function(string) {
    	return string.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
    },
    reloadPrice: function(product_handle) {
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        var flag = true;
        $(product.variants).each(function (i, v) {
          if (selectedOptions == v.title) {
            var price = theme.Currency.formatMoney(v.price,theme.moneyFormat);
            var original_price = theme.Currency.formatMoney(v.compare_at_price,theme.moneyFormat);
            var v_inv = v.inventory_management;
            if(v.featured_image != null)
            {
            	$('.slick-current img').attr('src',v.featured_image.src);
            }            
            flag = false;
            $('.qv-product-price').html(price);
            $('.qv-product-original-price').html(original_price);
            if (v_inv == null) {
              $(".qv-add-button.quick-product").removeAttr("disabled");
              $('#AddToCartText-product-template').html("Add to cart");
            } else {
              if (!v.available) {
                $('.qv-add-button.quick-product').attr('disabled','disabled');
                $('#AddToCartText-product-template').html("Sold out");
              } else {
                $(".qv-add-button.quick-product").removeAttr("disabled");
                $('#AddToCartText-product-template').html("Add to cart");
              }
            }
            if(jQuery('[name=currencies]').length){
              Currency.convertAll(theme.shopCurrency, jQuery('[name=currencies]').val());
            }
          } 
//               else if(flag && product.options.length >1) {
//                 $('.qv-add-button.quick-product').attr('disabled','disabled');
//                 $('#AddToCartText-product-template').html("Sold out");
//             }
              if(v.options.length >= 1 && v.available){
                $(v.options).each(function (index, option) {
                  jQuery('.swatch[data-option-index="'+index+'"] .'+enercosQuickView.convertToSlug(option)).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
                });
              }                                                          
        });
      });	
    }
  };  
});  